import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams, Link } from 'react-router-dom';
import { useStudentAuth } from '../../../context/StudentAuthContext';
import { toast } from 'react-hot-toast';





const StudentQuizReview = () => {
  const { quizId, attemptId } = useParams();
  //  const { quizId, attemptId } = useParams();
  const navigate = useNavigate();
  const { studentApi } = useStudentAuth();
  const [attempt, setAttempt] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReview();
  }, [attemptId]);

    const fetchReview = async () => {
    try {
      setLoading(true);
      const response = await studentApi.get(`/student/quizzes/attempts/${attemptId}/review`);
      setAttempt(response.data.attempt);
      setQuestions(response.data.questions);
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error('You are not allowed to review this quiz.');
        navigate(`/student/quiz/${quizId}/attempts`);
      } else {
        toast.error('Failed to load review');
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  // const fetchReview = async () => {
  //   try {
  //     setLoading(true);
  //     const data = await studentApi.get(`/student/quizzes/attempts/${attemptId}/review`);
  //     setAttempt(data.data.attempt);
  //     setQuestions(data.data.questions);
  //   } catch (error) {
  //     toast.error('Failed to load review');
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getScoreColor = (score) => {
    if (score >= 80) return 'text-green-600';
    if (score >= 50) return 'text-yellow-600';
    return 'text-red-600';
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <Link to={`/student/quiz/${quizId}/attempts`} className="text-blue-600 hover:text-blue-800">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
        </Link>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Quiz Review</h1>
          <p className="text-gray-600">
            Score: <span className={`font-semibold ${getScoreColor(attempt?.score)}`}>
              {attempt?.score}%
            </span> • Completed: {attempt?.end_time ? new Date(attempt.end_time).toLocaleString() : 'N/A'}
          </p>
        </div>
      </div>

      {/* Questions */}
      <div className="space-y-4">
        {questions.map((q, idx) => (
          <div key={q.id} className="bg-white rounded-xl shadow border border-gray-100 p-6">
            <div className="flex justify-between items-start mb-4">
              <div className="flex items-center gap-2">
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                  Question {idx + 1}
                </span>
                <span className={`text-xs px-2 py-1 rounded-full ${
                  q.is_correct === true ? 'bg-green-100 text-green-800' :
                  q.is_correct === false ? 'bg-red-100 text-red-800' :
                  'bg-gray-100 text-gray-800'
                }`}>
                  {q.is_correct === true ? 'Correct' : q.is_correct === false ? 'Incorrect' : 'Not graded'}
                </span>
              </div>
              <span className="text-sm text-gray-500">{q.marks} mark{q.marks !== 1 ? 's' : ''}</span>
            </div>

            <div
              className="text-gray-800 mb-4 prose max-w-none"
              dangerouslySetInnerHTML={{ __html: q.question_text }}
            />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <p className="text-sm text-gray-500 mb-1">Your Answer:</p>
                <div className="p-3 bg-gray-50 rounded border border-gray-200">
                  {q.student_answer || '(No answer)'}
                </div>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Correct Answer:</p>
                <div className="p-3 bg-green-50 rounded border border-green-200">
                  {q.correct_answer || 'N/A'}
                </div>
              </div>
            </div>

            {q.explanation && (
              <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                <p className="font-medium text-blue-800 mb-1">Explanation:</p>
                <p className="text-blue-700 text-sm">{q.explanation}</p>
              </div>
            )}

            {q.options && q.options.length > 0 && (
              <div className="mt-4">
                <p className="text-sm text-gray-500 mb-2">All Options:</p>
                <div className="space-y-2">
                  {q.options.map((opt, optIdx) => {
                    const optLabel = opt.label || String.fromCharCode(65 + optIdx);
                    const isStudent = optLabel === q.student_answer;
                    const isCorrect = optLabel === q.correct_answer;
                    let bgClass = '';
                    if (isStudent && isCorrect) bgClass = 'bg-purple-50 border-purple-300';
                    else if (isStudent) bgClass = 'bg-blue-50 border-blue-300';
                    else if (isCorrect) bgClass = 'bg-green-50 border-green-300';
                    else bgClass = 'bg-gray-50 border-gray-200';
                    
                    return (
                      <div key={optIdx} className={`p-3 rounded-lg border ${bgClass}`}>
                        <div className="flex items-start">
                          <span className="font-bold text-gray-700 mr-3 min-w-6">{optLabel}.</span>
                          <span dangerouslySetInnerHTML={{ __html: opt.text || opt }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Actions */}
      <div className="flex justify-center pt-4">
        <Link
          to={`/student/quiz/${quizId}/attempts`}
          className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
        >
          Back to Attempts
        </Link>
      </div>
    </div>
  );
};

export default StudentQuizReview;